import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { Label } from '../ui';

// Searchable single-select. options: [{ value, label, sub }]
export const Picker = ({ label, required, value, onChange, options, placeholder = 'Search…', testid = 'picker', className = '', disabled }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const box = useRef(null);
  const sel = options.find((o) => o.value === value);

  useEffect(() => {
    const h = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const ql = q.trim().toLowerCase();
  const list = (ql ? options.filter((o) => `${o.label} ${o.sub || ''}`.toLowerCase().includes(ql)) : options).slice(0, 50);

  return (
    <div ref={box} className={`relative ${className}`}>
      {label && <Label required={required}>{label}</Label>}
      <button type="button" disabled={disabled} onClick={() => setOpen((o) => !o)} data-testid={testid}
        className="erp-input flex items-center justify-between gap-2 text-left disabled:opacity-60" style={{ color: sel ? 'var(--erp-ink)' : '#a3abbf' }}>
        <span className="truncate">{sel ? sel.label : placeholder}</span>
        <ChevronDown size={15} style={{ color: 'var(--erp-muted)' }} />
      </button>
      {required && <input tabIndex={-1} aria-hidden className="absolute opacity-0 h-0 w-0 bottom-0 left-4" required value={value || ''} onChange={() => {}} />}
      {open && (
        <div className="absolute z-[120] mt-1.5 w-full min-w-[260px] erp-card overflow-hidden erp-rise" data-testid={`${testid}-menu`}>
          <div className="p-2 border-b" style={{ borderColor: 'var(--erp-line)' }}>
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Type to filter…" className="erp-input !h-9" data-testid={`${testid}-search`} />
          </div>
          <ul className="max-h-60 overflow-y-auto erp-scroll py-1">
            {list.length === 0 && <li className="px-3 py-2 text-sm" style={{ color: 'var(--erp-muted)' }}>No matches</li>}
            {list.map((o) => (
              <li key={o.value}>
                <button type="button" onClick={() => { onChange(o.value, o); setOpen(false); setQ(''); }} data-testid={`${testid}-opt-${o.value}`}
                  className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm hover:bg-[#f5f7fb] transition-colors">
                  <span className="flex-1 min-w-0"><span className="block font-semibold truncate">{o.label}</span>{o.sub && <span className="block text-xs truncate" style={{ color: 'var(--erp-muted)' }}>{o.sub}</span>}</span>
                  {o.value === value && <Check size={14} style={{ color: 'var(--erp-blue)' }} />}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
